export default __webpack_public_path__ + "static/media/benin.7ab0ca6b.webp";